import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-engine-model-progress-strip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './engine-model-progress-strip.component.html',
  styleUrls: ['./engine-model-progress-strip.component.scss']
})
export class EngineModelProgressStripComponent {
  data: any;
  readonly leftLabel = 'MFN/Star';
  readonly leftValue = 0.5;
  readonly rightValue = 1.0;
  readonly markerSubValue = '$188K';
  markerPercent = 50;
  private dragging = false;

  get markerValue(): string {
    const value = this.leftValue + (this.markerPercent / 100) * (this.rightValue - this.leftValue);
    return `${value.toFixed(2)}%`;
  }

  get leftValueLabel(): string {
    return `${this.leftValue}%`;
  }

  get rightValueLabel(): string {
    return `${this.rightValue}%`;
  }

  get containerHeight(): string {
    const configuredHeight = String(this.data?.containerHeight ?? '').trim();
    return configuredHeight || '46px';
  }

  onTrackPointerDown(event: PointerEvent, track: HTMLElement): void {
    this.dragging = true;
    track.setPointerCapture(event.pointerId);
    this.updateFromPointer(event, track);
  }

  onTrackPointerMove(event: PointerEvent, track: HTMLElement): void {
    if (!this.dragging) {
      return;
    }
    this.updateFromPointer(event, track);
  }

  onTrackPointerUp(event: PointerEvent, track: HTMLElement): void {
    this.dragging = false;
    if (track.hasPointerCapture(event.pointerId)) {
      track.releasePointerCapture(event.pointerId);
    }
  }

  private updateFromPointer(event: PointerEvent, track: HTMLElement): void {
    const rect = track.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const rawPercent = (x / rect.width) * 100;
    this.markerPercent = Math.max(0, Math.min(100, rawPercent));
  }
}
